import React from "react";
import imageUrl from "utils/imageUrl";
function NftDetails() {
  return (
    <div className="group__two">
      <h5>Nft Details</h5>
      <ul>
        <li>
          Contract Address: <span>0x495f...7b5e</span>
        </li>
        <li>
          Token ID: <span>0x495f...7b5e</span>
        </li>
        <li>
          Token Standard: <span>ERC-1155</span>
        </li>
        <li>Chain: Ethereum</li>
        <li>Metadata: Centralized</li>
        <li>Creator Fee: 10%</li>
      </ul>
    </div>
  );
}

export default NftDetails;
